<app-rc-dialog-wrapper noClose="true">
  <div class="delete-patient-dialog">
    <div class="delete-patient-dialog__body">
      <!-- Image -->
      <div class="delete-patient-dialog__body-thumb">
        <img src="assets/other/img-australian-shepherd.png" alt="Are you sure you want to delete this profile?" />
      </div>

      <!-- Text -->
      <h3 class="rc-title-gamma" i18n="@@delete-patient_title">Are you sure you want to delete this profile?</h3>
      <p class="rc-paragraph" i18n="@@delete-patient_text">All data will be erased</p>
    </div>

    <div class="delete-patient-dialog__footer">
      <div class="rc-button-group">
        <rc-link data-qa="vs-pet-owner-profile-delete-pet-profile-button-cancel" variant="secondary" size="large" (click)="dismiss()">
          {{ 'action_cancel' | translateKey }}
        </rc-link>
        <span class="rc-button__separator" i18n="@@action_separator">or</span>
        <rc-button data-qa="vs-pet-owner-profile-delete-pet-profile-button-delete" (click)="continue()">
          {{ 'action_delete' | translateKey }}
        </rc-button>
      </div>
    </div>
  </div>
</app-rc-dialog-wrapper>
